import type { ComponentPropsWithRef } from 'react';
import { TextAlignmentOptionsName } from '#const';

export type ButtonVariant = 'Default' | 'Phone CTA';

/** NANP validation: 10 digits, area code and exchange start with 2–9. */
export const NANP_DIGITS_REGEX = /^[2-9]\d{2}[2-9]\d{6}$/;

export type ButtonProps = ComponentPropsWithRef<'button'> & {
	children?: never;
	extendStyles?: string;
	variant?: ButtonVariant;
	/** Button text (Default variant) */
	copy?: string;
	/** Desktop-only text (Phone CTA variant) */
	desktopCopy?: string;
	/** Mobile-only text (Phone CTA variant) */
	mobileCopy?: string;
	color?: string;
	arrow?: boolean;
	href?: string;
	buttonAlignment: TextAlignmentOptionsName;
	textColor?: string;
	usePageColors?: boolean;
	scrollTo?: boolean;
	hover?: string;
	wideButton?: boolean;
	/** Set to true to open the FormModal instead of navigating (Default variant only) */
	openModal?: boolean;
	logPostHogEvent?: boolean;
	buttonId?: string;
	/** Static phone number stored as "(XXX) XXX-XXXX" (Phone CTA variant only) */
	phoneNumber?: string;
	/** Fetch dynamic phone number from URL params (Phone CTA variant only) */
	showDynamicPhoneNumber?: boolean;
	builderState?: unknown;
	builderBlock?: unknown;
};
